module.exports = __webpack_public_path__ + "static/media/fr_MIDbooklet_both_highlighted@2x.1f16d7c1.png";